import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from '../themeBase';

const ColorModeContext = createContext({ mode: 'dark', toggle: () => {}, setMode: () => {} });

export const ColorModeProvider = ({ children }) => {
  const [mode, setModeState] = useState(() => localStorage.getItem('colorMode') || 'dark');

  const setMode = useCallback((m) => {
    setModeState(m);
    localStorage.setItem('colorMode', m);
  }, []);
  const toggle = useCallback(() => setMode(mode === 'dark' ? 'light' : 'dark'), [mode, setMode]);

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={{ mode, setMode, toggle }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export const useColorMode = () => useContext(ColorModeContext);
export default ColorModeContext;
